/**
 * promotionInference — MP-07 (review): the ONE place a promoting choice is ever inferred.
 *
 * Every value returned here is one of the five live keys the form offers. The retired values
 * (personal-brand, service-business) are DISPLAY-ONLY for rows that already carry them
 * (founder decision 19) — nothing may generate them for a new campaign, or a brand-new record
 * opens wearing a "previously saved" label for a choice nobody made.
 */
import { PILLS } from '../../../../section-builder/backend/services/teaserQuestions.js';

const LIVE_KEYS = PILLS.map((p) => p.key);

/** From scraped product data (name/description/offer fields). */
export function inferFromProductData(productData) {
    if (!productData) return 'product';
    const text = `${productData.description || ''} ${productData.name || ''}`.toLowerCase();
    if (text.includes('consulting') || text.includes('coaching')) return 'service';
    if (text.includes('course') || text.includes('training') || text.includes('workshop')) return 'course';
    return 'product';
}

/** From an older record's businessModel field. */
export function inferFromBusinessModel(businessModel) {
    const m = (businessModel || '').toLowerCase();
    if (m.includes('service') || m.includes('consult') || m.includes('coach') || m.includes('agency')) return 'service';
    if (m.includes('course') || m.includes('training') || m.includes('education')) return 'course';
    return 'product';
}

/** Every inference lands on a live key — pinned by test, never by trust. */
export function isLiveKey(value) {
    return LIVE_KEYS.includes(value);
}
